import React, { useContext } from "react";
import styles from "./layout.module.css";
import Sidebar from "components/Sidebar";
import { useLocation } from "react-router-dom";
import SearchHeader from "common/Header/search";
import Header from "common/Header/normal";
import SidebarC from "common/Sidebar";
import { BurgerMenuContext } from "context/sidebar";
import { Toaster } from "react-hot-toast";

const Layout = ({ children }) => {
  const location = useLocation();
  const sideBarRoutes = [
    "/home",
    "/analytics",
    "/event",
    "/my-account",
    "/event/create-event",
    "/event/edit-event",
    "/finance",
    "/sales",
    "/ticket",
    "/ticket/create-ticket",
    "/setting",
    "/orders",
    "/package",
    "/notifications",
    "/referral",
    "/journey",
    "/manage-admins",
  ];

  const normalHeaderRoutes = [
    "/",
    "/login",
    "/signup",
    "/forgot-password",
    "/otp-verification",
    "/reset-password",
    // "/home",
    // "/sales",
    // "/analytics",
    // "/finance",
    // "/setting",
  ];

  const shouldShowSidebar = sideBarRoutes.some((e, i) =>
    location.pathname?.startsWith(e)
  );

  const shouldShowNormalHeader = normalHeaderRoutes.includes(location.pathname);

  const sideBarprops = useContext(BurgerMenuContext);

  return (
    <div className={styles.layout} id="outer-layout">
      <Toaster position="bottom-center" reverseOrder={false}
      toastOptions={{
        className: '',
        style: {
          padding: '1.6rem',
          fontSize:"1.6rem"
        },
      }}
    
      />
      {sideBarprops?.showSideBar && <SidebarC {...sideBarprops} />}
      {shouldShowNormalHeader ? <Header /> : <SearchHeader />}
      <div
        id="outer-container"
        className={shouldShowSidebar ? styles.outerContainer : ""}
      >
        {shouldShowSidebar && (
          <Sidebar
            open={true}
            pageWrapId="page-wrap"
            outerContainerId="outer-container"
          />
        )}
        <div
          id="page-wrap"
          className={shouldShowSidebar ? styles.pageWrap : ""}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default Layout;
